// Django's help text for the password validators. Guidance only; the API does not enforce these yet.
export const PASSWORD_RULES = [
  'Your password must contain at least 8 characters.',
  'Your password can\u2019t be entirely numeric.',
  'Your password can\u2019t be a commonly used password.',
  'Your password can\u2019t be too similar to your other personal information.',
];
